/* src/app/workshop/modals/defect-modal/defect-modal.component.scss */
/*# sourceMappingURL=defect-modal.component.css.map */
